
import Vue from "vue";
import i18n from "@/i18n";
import axios from "@/plugins/axios";
import InformationDDC from "./InformationDDC.vue";
import formatUtil from "../../mixins/roundValues";
import highlightReports from "../../mixins/highlightReports";
import { formatFinancialAmounts, formatTwoDecimal } from "../../utils/format";

export default Vue.extend({
  name: "Hemophilia-Productuse",
  components: { InformationDDC },
  mixins: [formatUtil, highlightReports],
  data: () => ({
    data: [],
    isLoading: false,
    bleedingDisorderSelected: [],
    bleedingDisorders: [],
    payload: {
      year: null,
      diseaseType: [] as number[],
    },
  }),
  computed: {
    maxtableHeight() {
      return window.screen.height - window.screen.height * 0.2;
    },
    title() {
      return i18n.t("reports.ddcreports.listReports.hemophiliaProductUse");
    },
    yearSelected() {
      return this.$store.getters["ddcreport/getYearSelected"].year;
    },
    headers() {
      return [
        {
          text: i18n.t("reports.ddcreports.hemophiliaProductUse.n"),
          value: "n",
        },
        {
          text: i18n.t("reports.ddcreports.hemophiliaProductUse.country"),
          value: "country",
        },
        {
          text: i18n.t("reports.ddcreports.hemophiliaProductUse.region"),
          value: "region",
        },
        {
          text: i18n.t("reports.ddcreports.hemophiliaProductUse.surveyYear"),
          value: "surveyYear",
        },
        {
          text: i18n.t("reports.ddcreports.hemophiliaProductUse.dataYear"),
          value: "dataYear",
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previousSurveyYear"
          ),
          value: "previousSurveyYear",
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previousDataYear"
          ),
          value: "previousDataYear",
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.current_Plasma_Total"
          ),
          value: "current_Plasma_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previous_Plasma_Total"
          ),
          value: "previous_Plasma_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.plasma_Count_Perc_Diff"
          ),
          value: "plasma_Count_Perc_Diff",
        },

        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.current_Cryoprecipitate_Total"
          ),
          value: "current_Cryoprecipitate_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previous_Cryoprecipitate_Total"
          ),
          value: "previous_Cryoprecipitate_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.cryoprecipitate_Count_Perc_Diff"
          ),
          value: "cryoprecipitate_Count_Perc_Diff",
        },

        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.current_PDC_Total"
          ),
          value: "current_PDC_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previous_PDC_Total"
          ),
          value: "previous_PDC_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.pdC_Count_Perc_Diff"
          ),
          value: "pdC_Count_Perc_Diff",
        },

        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.current_RC_phl_Total"
          ),
          value: "current_RC_phl_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previous_RC_phl_Total"
          ),
          value: "previous_RC_phl_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.rC_phl_Count_Perc_Diff"
          ),
          value: "rC_phl_Count_Perc_Diff",
        },

        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.current_RC_ex_phl_Total"
          ),
          value: "current_RC_ex_phl_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previous_RC_ex_phl_Total"
          ),
          value: "previous_RC_ex_phl_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.rC_ex_phl_Count_Perc_Diff"
          ),
          value: "rC_ex_phl_Count_Perc_Diff",
        },

        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.current_DDAVP_Total"
          ),
          value: "current_DDAVP_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previous_DDAVP_Total"
          ),
          value: "previous_DDAVP_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.ddavP_Count_Perc_Diff"
          ),
          value: "ddavP_Count_Perc_Diff",
        },

        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.current_Altuviiio_Total"
          ),
          value: "current_Altuviiio_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previous_Altuviiio_Total"
          ),
          value: "previous_Altuviiio_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.altuviiio_Count_Perc_Diff"
          ),
          value: "altuviiio_Count_Perc_Diff",
        },

        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.current_Emicizumab_inhibitor_Total"
          ),
          value: "current_Emicizumab_inhibitor_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previous_Emicizumab_inhibitor_Total"
          ),
          value: "previous_Emicizumab_inhibitor_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.emicizumab_inhibitor_Count_Perc_Diff"
          ),
          value: "emicizumab_inhibitor_Count_Perc_Diff",
        },

        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.current_Emicizumab_ex_inhibitor_Total"
          ),
          value: "current_Emicizumab_ex_inhibitor_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previous_Emicizumab_ex_inhibitor_Total"
          ),
          value: "previous_Emicizumab_ex_inhibitor_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.emicizumab_ex_inhibitor_Count_Perc_Diff"
          ),
          value: "emicizumab_ex_inhibitor_Count_Perc_Diff",
        },

        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.current_RebalancingAgents_inhibitor_Total"
          ),
          value: "current_RebalancingAgents_inhibitor_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previous_RebalancingAgents_inhibitor_Total"
          ),
          value: "previous_RebalancingAgents_inhibitor_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.rebalancingAgents_inhibitor_Count_Perc_Diff"
          ),
          value: "rebalancingAgents_inhibitor_Count_Perc_Diff",
        },

        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.current_RebalancingAgents_ex_inhibitor_Total"
          ),
          value: "current_RebalancingAgents_ex_inhibitor_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.previous_RebalancingAgents_ex_inhibitor_Total"
          ),
          value: "previous_RebalancingAgents_ex_inhibitor_Total",
          formatter: (val: number): number | string =>
            formatFinancialAmounts(val),
        },
        {
          text: i18n.t(
            "reports.ddcreports.hemophiliaProductUse.rebalancingAgents_ex_inhibitor_Count_Perc_Diff"
          ),
          value: "rebalancingAgents_ex_inhibitor_Count_Perc_Diff",
        },
      ];
    },
  },
  methods: {
    getData() {
      this.isLoading = true;
      this.payload.year = this.yearSelected;
      axios
        .get("report/DDC/Review-ProductsUse", {
          params: { year: this.yearSelected },
        })
        .then((res: any) => {
          this.data = res.data;
          this.isLoading = false;
        })
        .catch((err) => console.log(err));
    },
    exportData() {
      axios
        .get(`report/ddc/Review-ProductsUse/export`, {
          params: { year: this.yearSelected },
          responseType: "blob",
        })
        .then((res) => {
          const fileName =
            `${i18n.t("reports.ddcreports.pagetitle")} -` + this.title;
          this.downloadExcel(fileName, res.data);
        })
        .catch((err) => console.log(err));
    },
    downloadExcel(fileName: string, data: any) {
      const blob = new Blob([data], { type: "application/xlsx" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName + ".xlsx";
      link.click();
    },
  },
  created() {
    if (this.yearSelected) {
      this.getData();
    }
  },
  watch: {
    yearSelected() {
      this.getData();
    },
  },
});
